import React, { useState } from 'react'
import '../assets/css/hero.css'
import heroBg from "../assets/images/bg-image/hero-bg.png";
import { GoCheckCircleFill } from 'react-icons/go';
import QuoteModal from './QuoteModal';

function Hero({ onProductClick }) {

    const [open, setOpen] = useState(false);

    return (
        <>
            <section className="hero-section">
                <div
                    className="hero-shell"
                    style={{ backgroundImage: `url(${heroBg})` }}
                >

                    {/* Content card */}
                    <div className="hero-card" data-aos="fade-down">
                        <h1>
                            High-Performance <br />
                            Industrial Resins
                        </h1>

                        <p>
                            Delivering superior bonding strength, consistency, and reliability
                            since 2014. Trusted by manufacturers across India.
                        </p>

                        <div className="hero-buttons">
                            <button className="animated-btn" onClick={() => setOpen(true)}>
                                <span className="btn-text-wrap">
                                    <span className="btn-text">Get a Quote</span>
                                    <span className="btn-text btn-text-abs">Get a Quote</span>
                                </span>
                            </button>
                            <button className="animated-btn call-btn" onClick={onProductClick} style={{ backgroundColor: '#E1F3FA', color: "#000" }}>
                                <span className="btn-text-wrap">
                                    <span className="btn-text">Explore Products</span>
                                    <span className="btn-text btn-text-abs">Explore Products</span>
                                </span>
                            </button>
                        </div>

                        <QuoteModal isOpen={open} onClose={() => setOpen(false)} />

                        <div className="hero-features">
                            <span><GoCheckCircleFill style={{ color: '#0f766e', fontSize: '20px' }} /> Reliable Quality</span>
                            <span><GoCheckCircleFill style={{ color: '#0f766e', fontSize: '20px' }} /> On-Time Delivery</span>
                            <span><GoCheckCircleFill style={{ color: '#0f766e', fontSize: '20px' }} /> Advanced Technology</span>
                        </div>
                    </div>

                </div>
            </section>
        </>
    )
}

export default Hero